<div>
    <a [routerLink]="['/' + currentCase + '/Login']" class="login-client-logo">
        <img [src]="logoUrl" />
    </a>
    <span class="login-client-logo-text">
        Powered by <strong>Winston</strong>
    </span>
</div>